// extracted by mini-css-extract-plugin
export default {"main":"Team_main__ZqkyO","title":"Team_title__XN5NM","description":"Team_description__KSGRt","content":"Team_content__lpxcy","slider":"Team_slider__RBife"};